import { apiService } from './apiService';

export const connectionProfileService = {
  async getAll() {
    return await apiService.get('/connection-profiles');
  },

  async getById(id: string | number) {
    return await apiService.get(`/connection-profiles/${id}`);
  },

  async create(data: any) {
    return await apiService.post('/connection-profiles', data);
  },

  async update(id: string | number, data: any) {
    return await apiService.put(`/connection-profiles/${id}`, data);
  },

  async delete(id: string | number) {
    return await apiService.delete(`/connection-profiles/${id}`);
  },
};
